import {InfoCircleOutlined} from "@ant-design/icons";
import {Tooltip} from "antd";
import {ReactElement, ReactNode} from "react";

export default function ViewTooltip({ title, children }: {title:string|ReactNode, children?:ReactNode}) {
    return <>{title?<Tooltip placement="top" title={title}>
        { children }
    </Tooltip>:null}</>
}